//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'dale_paddle',
    colors: ['#ff7a5a', '#765aa6', '#fee7bc', '#515e8c', '#ffc64a', '#b460a6', '#ffffff', '#4781c1'],
    stroke: '#000000',
    background: '#abe9e8',
    type: 'dale',
  },
  {
    name: 'dale_night',
    colors: ['#ae5d9d', '#f1e8bc', '#ef8fa3', '#f7c047', '#58c9ed', '#f77150'],
    stroke: '#000000',
    background: '#00ae83',
    type: 'dale',
  },
  {
    name: 'dale_cat',
    colors: ['#f77656', '#f7f7f7', '#efc545', '#dfe0e2', '#3c70bd', '#66bee4'],
    stroke: '#000000',
    background: '#f6e0b8',
    type: 'dale',
  },
];
